import React from "react";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../services/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function CreateHoliday({
  closeModal,
  alert,
  categoryType,
  getRequest,
}) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          event_type: "",
          event_category: "",
          event_start_date: new Date(),
          event_end_date: new Date(),
        }}
        onSubmit={(values) => {
          ApiService.post("holidays/set-holiday", values).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            // AllRequest()
            getRequest();
            closeModal();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
          <Form>
            <div className="form-group">
              <label>
                {" "}
                Event Name<span className="text-danger"> * </span>
              </label>
              <Field
                type="text"
                className="form-control"
                id="event_type"
                name="event_type"
                required
              />
            </div>
            <div className="form-group">
              <label>
                {" "}
                Event Category<span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                id="event_category"
                name="event_category"
                required
              >
                <option value="">--Select event category--</option>

                {categoryType.map((cat, i) => (
                  <option value={cat.id} key={i}>
                    {cat.name}
                  </option>
                ))}
              </Field>
            </div>
            <label>
              {" "}
              Start Date <span className="text-danger"> * </span>
            </label>

            <div className="form-group">
              <DatePicker
                selected={values.event_start_date}
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="start_date"
                minDate={new Date()}
                onChange={(date) => setFieldValue("event_start_date", date)}
                required
              />
            </div>
            <label>
              {" "}
              End Date <span className="text-danger"> * </span>
            </label>

            <div className="form-group">
              <DatePicker
                selected={values.event_end_date}
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="end_date"
                minDate={new Date()}
                onChange={(date) => setFieldValue("event_end_date", date)}
                required
              />
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/calendar/create_holiday.js